import { showError } from '@components/app-error';
import { Inputs, useEffect } from 'preact/hooks';

export function useAsyncEffect(fn: () => Promise<unknown>, inputs: Inputs = []) {
  useEffect(() => {
    fn().catch(showError);
  }, inputs);
}
